import { Component } from 'react';
import { connect, PromiseState } from 'react-refetch';
import Helmet from 'react-helmet';

import Icon from 'react-fa';

import { api, titles } from '../data';

import LoadingAnimation from './modules/LoadingAnimation';
import Title from './modules/Title';

class Entry extends Component {
  render() {

    const page = this.props.page;

    const userMember = page.acf.entry_user_member;
    const corpMember = page.acf.entry_corp_member;
    const subMember = page.acf.entry_sub_member;

    const contactDesc = page.acf.entry_contact_desc;
    const contactInfo = page.acf.entry_contact_info;

    return (
      <div>
        <Helmet title={titles.entry} titleTemplate={titles.titleTemplate} />
        <section className="entry">
          <Title header="h1" title="入会のご案内" />
          <div className="entry__content">
            <table className="entry__table">
              <tbody>

                {/* 利用会員 */}
                {userMember
                  ?
                    <tr><th className="main-th regular-member" rowSpan={userMember.length + 1}>利用会員</th></tr>
                  : ''
                }
                {userMember
                  ?
                    userMember.map(item => {
                      return(
                        <tr key={item.title} className="regular-member">
                          <th className="table-sub-title">{item.title}</th>
                          <td className="table-sub-content" dangerouslySetInnerHTML={{__html: item.content}} />
                        </tr>
                      )
                    })
                  : ''
                }

                <tr className="spacer"></tr>

                {/* 賛助会員 */}
                {subMember
                  ?
                    <tr><th className="main-th sub-member" rowSpan={subMember.length + 1}>賛助会員</th></tr>
                  : ''
                }
                {subMember
                  ?
                    subMember.map(item => {
                      return(
                        <tr key={item.title} className="sub-member">
                          <th className="table-sub-title">{item.title}</th>
                          <td className="table-sub-content" dangerouslySetInnerHTML={{__html: item.content}} />
                        </tr>
                      )
                    })
                  : ''
                }

                <tr className="spacer"></tr>

                {/* 協力会員 */}
                {corpMember
                  ?
                    <tr><th className="main-th corp-member" rowSpan={corpMember.length + 1}>協力会員</th></tr>
                  : ''
                }
                {corpMember
                  ?
                    corpMember.map(item => {
                      return(
                        <tr key={item.title} className="corp-member">
                          <th className="table-sub-title">{item.title}</th>
                          <td className="table-sub-content" dangerouslySetInnerHTML={{__html: item.content}} />
                        </tr>
                      )
                    })
                  : ''
                }

              </tbody>
            </table>

            <div className="entry__contact">
              <h3 className="entry__contact__title"><span><Icon name="envelope-o" />申し込み・問い合わせ</span></h3>
              <div className="entry__contact__content">
                {contactDesc
                  ?
                    <div className="entry__contact__content__desc" dangerouslySetInnerHTML={{__html: contactDesc}} />
                  : ''
                }
                {contactInfo
                  ?
                  <table className="entry__contact__content__table">
                    <thead>
                      <tr><th colSpan="2">お問い合わせ先</th></tr>
                    </thead>
                    <tbody>
                      {contactInfo.map(item => {
                        return(
                          <tr key={item.title}>
                            <th>{item.title}</th>
                            <td>{item.content}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  : ''
                }
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

class EntryFetch extends Component {
  render() {

    const { pageFetch } = this.props;

    const allFetches = PromiseState.all([pageFetch])

    // Pending
    if (allFetches.pending) {

      return <LoadingAnimation />

    // Error
    } else if (allFetches.rejected) {

      return <div>Error</div>

    // Complete without Error
    } else if (allFetches.fulfilled) {

      let [page] = allFetches.value;
      page = page[0];

      return (
        <Entry page={page} />
      )
    }
  }
}

export default connect(() => ({
  pageFetch: `${api.base_url}/pages?slug=entry`
}))(EntryFetch);



/** WEBPACK FOOTER **
 ** ./src/components/Entry.js
 **/